import { Typography } from 'antd'

import { Unanswered } from '../DisplayBlock.style'

import { TimezonedDate } from '@/context/timezoneContext'
import { DateTimeDisplayBlock as DateTimeDisplayBlockType } from '@/modules/templates/types/blueprint'

export const renderTimezonedDateBlock = (
  captureRange,
  value,
  pickerType: DateTimeDisplayBlockType['pickerType'],
  longForm = true
) => {
  if (!value) {
    return '-'
  }

  return captureRange && Array.isArray(value) ? (
    value.map((date, index) => (
      <>
        <TimezonedDate
          key={index}
          date={date}
          includeDate={pickerType !== 'time'}
          includeTime={pickerType === 'dateTime' || pickerType === 'time'}
          longForm={longForm}
        />
        {value[index + 1] && ' - '}
      </>
    ))
  ) : (
    <TimezonedDate
      date={value}
      includeDate={pickerType !== 'time'}
      includeTime={pickerType === 'dateTime' || pickerType === 'time'}
      longForm={longForm}
    />
  )
}

type Props = {
  block: DateTimeDisplayBlockType
}

export const DateTimeDisplayBlock: React.FC<Props> = ({ block }) => {
  const { content, showTime, pickerType, captureRange } = block

  const picker = pickerType || (showTime ? 'dateTime' : 'date')

  if (!content) return <Unanswered />

  return (
    <Typography.Text>
      {renderTimezonedDateBlock(captureRange, content, picker)}
    </Typography.Text>
  )
}
